import angular from 'angular';
import { ResubmitFailedOrderComponent } from './resubmit-failed-order.component';
export var ResubmitFailedOrderModule = angular
    .module('ResubmitFailedOrder', [])
    .component('resubmitFailedOrder', ResubmitFailedOrderComponent)
    .config(function ($stateProvider) {
    'ngInject';
    $stateProvider
        .state('resubmitFailedOrder', {
        url: '/account/orders/unprocessed-orders/:orderId/resubmit',
        template: '<resubmit-failed-order></resubmit-failed-order>',
        authenticate: true,
        params: {
            orderId: null,
            isAkrisOrder: false
        }
    });
})
    .name;
//# sourceMappingURL=resubmit-failed-order.module.js.map